/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */

import Vue from 'vue';
import Vuex from 'vuex';
import humps from 'humps';
import merge from 'deepmerge';
import userDeprecated from './store/promoter/userDeprecated';
import user from './store/user';
import globalMessage from './store/globalMessage';
import waitingForServer from './store/waitingForServer';
import promoter from './store/promoter/promoter';
import legalPeople from './store/promoter/legalPeople';
import activity from './store/promoter/activity';
import adminActivities from './store/admin/activities';
import adminUsers from './store/admin/users';
import adminPayments from './store/admin/payments';
import adminBookings from './store/admin/bookings';
import activityPublic from './store/public/activity';
import bookingPublic from './store/public/booking';
import bookingPromoter from './store/promoter/booking';
import occurrencePromoter from './store/promoter/occurrences';
import transactionsPromoter from './store/promoter/transactions';
import activityUI from './store/public/activityUI';
import activityImage from './store/promoter/activityImage';
import activitiesCalendar from './store/promoter/activitiesCalendar';
import kyc from './store/promoter/kyc';
import publicCalendar from './store/public/calendar';
import client from './store/public/client';
import search from './store/public/search';
import categories from './store/categories';
import groups from './store/groups';
import countries from './store/countries';
import locations from './store/locations';
import wallet from './store/public/wallet';
import recomendations from './store/public/recomendations';
import searchRecomendations from './store/public/searchRecomendations';
import bankAccount from './store/bankAccount';
import request from './request';

Vue.use(Vuex);
// Check example at: https://github.com/vuejs/vuex/blob/dev/examples/counter/store.js
// Don't forget to implement the mapper in components https://github.com/vuejs/vuex/blob/dev/examples/counter/Counter.vue
const state = {
  saveSuccess: false,
  saveError: false,
  waiting: false,
  previousUrl: undefined,
  app: {
    apiURL: process.env.API_URL,
    apiPublicUrl: process.env.API_PUBLIC_URL,
  },
  jwt: '',
  language: 'pt',
  locales: {
    pt: {
      allDayText: ['Todo o dia'],
      weekdaysShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
      weekdaysLong: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
      monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun',
        'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril',
        'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],

      calendarButtons: {
        today: 'hoje',
        month: 'mês',
        week: 'semana',
        day: 'dia',
        list: 'lista',
      },
    },
    en: {
      allDayText: ['All day'],
      weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      weekdaysLong: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursdays', 'Friday', 'Saturday'],
      monthNamesShort: ['Jan', 'Feb', 'Mar', 'May', 'Jun', 'Jul',
        'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      monthNames: ['January', 'February', 'March', 'April', 'May',
        'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      calendarButtons: {
        today: 'today',
        month: 'month',
        week: 'week',
        day: 'day',
        list: 'list',
      },
    },
  },
  showAllValidationErrors: false,
};

const storageJWT = localStorage.getItem('jwt');
if (storageJWT !== 'undefined') {
  state.jwt = storageJWT;
}
const storageUser = localStorage.getItem('user');
if (storageUser !== 'undefined') {
  state.user = JSON.parse(storageUser);
}

const mutations = {
  setShowAllValidationErrors(state, payload) {
    Object.assign(state, { showAllValidationErrors: payload });
  },
  setLanguage(state, language) {
    let l = language;
    if (l === null) {
      l = 'en';
    }
    state.language = l;
    document.getElementsByTagName('html')[0].setAttribute('lang', l);
  },
  getJWT() {
    return state.jwt;
  },
  logout(state) {
    state.user = {};
    state.jwt = '';
    localStorage.removeItem('user');
    localStorage.removeItem('jwt');
    localStorage.removeItem('promoter');
    const language = state.language;
    window.location = `/${language}/login`;
  },
  clearState(state) {
    const language = state.language;
    Object.assign(state, {});
    localStorage.removeItem('user');
    localStorage.removeItem('jwt');
    window.location = `/${language}/login?expired&returnTo=${window.location.pathname}`;
  },
  setPreviousUrl(state, url) {
    Object.assign(state, { previousUrl: url });
  },
};

const actions = {
  setPreviousUrl(context, url) {
    context.commit('setPreviousUrl', url);
  },
  setJWT(context, token) {
    return new Promise((resolve) => {
      localStorage.setItem('jwt', token);
      context.state.jwt = token;
      resolve();
    });
  },
  validateForm(context, payload) {
    const collection = payload.collection;
    const index = parseInt(payload.index, 10);
    let submitObject = {};
    if (!payload.autoSave) {
      submitObject = { validateOnly: true };
    }
    let formObj = {};
    if (typeof payload.index !== 'undefined') {
      formObj = context.rootState[collection].form[index];
    } else {
      formObj = context.rootState[collection].form;
    }
    const formKeys = Object.keys(formObj);
    formKeys.forEach((key) => {
      if (formObj[key].autoValidate !== false) {
        let name = '';
        if (typeof payload.index !== 'undefined' &&
          typeof context.rootState[collection].form[index][key].value === 'undefined') {
          name = context.rootState[collection].form[index][key].name;
        } else {
          name = context.rootState[collection].form[key].name;
        }
        let val;
        if (typeof formObj[key].options !== 'undefined' && formObj[key].sendSingle !== true) {
          if (formObj[key].options.length !== 1) {
            val = [];
            formObj[key].options.forEach((option) => {
              if (option.checked === true) {
                val.push(option.value);
              }
            });
          } else {
            val = formObj[key].options[0].checked;
          }
        } else {
          val = formObj[key].value;
        }
        const newObj = {};
        const nameArray = name.split('.');
        let o = newObj;
        for (let i = 0; i < nameArray.length; i += 1) {
          if (i === nameArray.length - 1) {
            o[nameArray[i]] = val;
            o = o[nameArray[i]];
          } else {
            o[nameArray[i]] = {};
            o = o[nameArray[i]];
          }
        }
        // submitObject = merge(submitObject, { [name]: val });
        submitObject = merge(submitObject, newObj);
      }
    });
    const urlPath = humps.decamelize(collection);
    let requestType = 'PUT';
    if (payload.autoSave) {
      requestType = 'PATCH';
    }
    request.make({
      type: requestType,
      url: `${process.env.API_URL}${urlPath}`,
      data: submitObject,
    }, (err, res) => {
      context.dispatch('setValidationErrors', {
        collection,
        body: res.body,
      });
      if (res.status === 200) {
        Object.assign(context.rootState[collection], { formValid: true });
      }
    });
  },
  setValidationErrors(context, payload) {
    const formKeys = Object.keys(context.rootState[payload.collection].form);
    formKeys.forEach((key) => {
      Object.assign(context.rootState[payload.collection].form[key], { errors: [] });
    });
    if (typeof payload.body !== 'undefined' && payload.body !== null) {
      if (typeof payload.body.errors !== 'undefined') {
        const errors = payload.body.errors;
        const keys = Object.keys(errors);
        keys.forEach((key) => {
          const fieldCamelCase = key.replace(/(_|\.)([a-z,0-9])/g,
            g => g[1].toUpperCase());
          Object.assign(context.rootState[payload.collection].form[fieldCamelCase],
            { errors: errors[key] });
        });
        Object.assign(context.rootState[payload.collection], { formValid: false });
      }
    }
  },
  showWaiting(context) {
    Object.assign(context.rootState, { waiting: true });
  },
  hideWaiting(context) {
    Object.assign(context.rootState, { waiting: false });
  },
  showSaveSuccess(context) {
    Object.assign(context.rootState, { saveSuccess: true });
    setTimeout(() => {
      Object.assign(context.rootState, { saveSuccess: false });
    }, 3000);
    window.jQuery('html, body').animate({ scrollTop: 0 }, 'slow');
  },
  showSaveError(context) {
    if (context.rootState.saveError === false) {
      Object.assign(context.rootState, { saveError: true });
      setTimeout(() => {
        Object.assign(context.rootState, { saveError: false });
      }, 3000);

      setTimeout(() => {
        if (window.jQuery('.validationErrors').length > 0) {
          window.jQuery('html, body').animate({
            scrollTop: window.jQuery('.validationErrors:first').offset().top
            - (window.jQuery(window).height() / 2),
          }, 800);
        }
      }, 0);
    }
  },
  setShowAllValidationErrors(context, payload) {
    context.commit('setShowAllValidationErrors', payload);
  },
};

// getters are functions
const getters = {
};

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  modules: {
    activity,
    activityUI,
    activitiesCalendar,
    activityImage,
    activityPublic, // front
    adminActivities, // admin
    adminPayments,
    adminUsers, // admin
    adminBookings,
    bankAccount,
    bookingPublic, // front
    bookingPromoter,
    categories,
    client, // front
    countries, // front
    globalMessage,
    groups,
    legalPeople,
    locations,
    kyc, // supplier kyc
    occurrencePromoter,
    promoter,
    publicCalendar, // front
    transactionsPromoter,
    recomendations, // front
    searchRecomendations, // front
    search, // front
    userDeprecated,
    waitingForServer,
    wallet,
    user,
  },
});



// WEBPACK FOOTER //
// ./src/store.js